import { APP_ERROR_CODE, AppErrorCode } from './app-error-code';

export const ERROR_MESSAGE_MAP: Record<AppErrorCode, string> = {
  [APP_ERROR_CODE.networkError]: 'No internet connection. Check your network.',
  [APP_ERROR_CODE.unauthorized]: 'Session expired. Please log in again.',
  [APP_ERROR_CODE.forbidden]: 'You do not have permission to perform this action.',
  [APP_ERROR_CODE.notFound]: 'Requested resource was not found.',
  [APP_ERROR_CODE.wheelVersionConflict]: 'Data was changed elsewhere. Please refresh.',
  [APP_ERROR_CODE.emailAlreadyUsed]: 'This email is already in use.',
  [APP_ERROR_CODE.subscriptionRequired]: 'This feature requires an active subscription.',
  [APP_ERROR_CODE.rateLimitExceeded]: 'Too many requests. Please try again later.',
  [APP_ERROR_CODE.internalServerError]: 'Something went wrong on our side.',

  [APP_ERROR_CODE.invalidOrExpiredResetPasswordToken]: 'You reset link seems to be invalid. Please, try again later or request a new one.',

  [APP_ERROR_CODE.emailVerificationToken]: 'Password reset link is invalid.',
  [APP_ERROR_CODE.emailVerificationTokenUsed]: 'Link is already used.',
  [APP_ERROR_CODE.emailVerificationTokenExpired]: 'Link has expired.',
  [APP_ERROR_CODE.emailVerificationInvalidUser]: 'Invalid or expired verification link.',
  [APP_ERROR_CODE.emailVerificationInvalidEmail]: 'Invalid or expired verification link.',

  [APP_ERROR_CODE.wheelLimitExceeded]: 'Maximum number of wheels (1) reached for this account',
  [APP_ERROR_CODE.wheelSessionsLimitExceeded]: 'Maximum number of sessions (5) reached for this account',
};

export const DEFAULT_ERROR_MESSAGE = 'Action could not be completed. Please try again.';
